import React from 'react';
import { Maybe, PagesQuery } from '../../generated/graphql';

interface Initial {
  getSafeCrop: (pageId: number, itemType: string) => SafeCrop;
}

export const SafeCropContext = React.createContext<Initial>({} as Initial);

type Page = PagesQuery['pages'][0];
type SafeCrop = Maybe<Page['supportedImageTypes'][0]> | undefined;

export const setupSafeCrop = (pages: Page[] | undefined | null) => (pageId: number, itemType: string): SafeCrop => {
  const page = (pages || []).find(p => p.id === pageId);
  const supportedImageType = (page?.supportedImageTypes || []).find(i => i.name === itemType);
  if (supportedImageType) return supportedImageType;
  return (page?.supportedImageTypes || []).find(i => i.name === 'PageItem'); // defaults to page item cropper if no item type match;
};
